import styled from 'styled-components';

const BenefitsStyle = styled.section`
	--marginT: var(--sp13x);
	--marginR: var(--sp10x);
	--wrapperMarginT: var(--sp9x);
	--titleMarginT: var(--sp6x);
	--titleMarginB: var(--sp4x);
	--gap: var(--sp6x);
	--borderRadius: var(--sp5x);
	--borderRadius2: var(--sp3x);
	--borderRadius3: var(--sp3x);
	--borderRadius4: var(--sp84x);
	--imageSize: 62%;
	--imageSize2: 142.7%;
	--imageSize3: var(--sp35x);
	--imageSize4: 45.4%;
	--imgMarginL: var(--sp8x);
	--imgMarginB: var(--sp9x);

	margin-top: var(--sectionDistance);
	overflow: hidden;

	.img-item {
		display: flex;
		align-items: end;
		div {
			width: 100%;
		}
	}

	.wrap-button {
		transform: scale(0);
		width: fit-content;
		height: fit-content;
	}

	.image-type-1 {
		margin-right: var(--marginR);

		.image-cont {
			--proportion: var(--imageSize);

			img {
				border-radius: var(--borderRadius);
			}
		}
	}

	.image-type-2 {
		width: 100%;

		.image-cont {
			--proportion: var(--imageSize2);

			img {
				border-radius: var(--borderRadius2);
			}
		}
	}

	.image-type-3 {
		margin-left: var(--imgMarginL);
		margin-bottom: var(--imgMarginB);
		width: var(--imageSize3);
		.image-cont {
			--proportion: var(--imageSize3);
			width: var(--imageSize3);

			img {
				border-radius: var(--borderRadius3);
			}
		}
	}

	.image-wrapper {
		display: flex;
		align-items: end;
		margin-right: var(--marginR);
	}

	.wrapper-benefits {
		margin-top: var(--wrapperMarginT);
	}

	.wrapper-benefits > div:nth-child(3) .image-cont {
		--proportion: var(--imageSize4) !important;

		img {
			border-radius: var(--borderRadius4) !important;
		}
	}

	.wrapper-titles {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.styled-text {
		text-transform: lowercase;
	}

	.benefit-item-title {
		margin: var(--titleMarginT) 0 var(--titleMarginB);
	}

	.benefit-info-wrapper {
		margin-right: var(--marginR);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginT: var(--sp10x);
		--marginR: var(--sp8x);
		--gap: var(--sp4x);
		--wrapperMarginT: var(--sp8x);
		--titleMarginB: var(--sp3x);
		--borderRadius: var(--sp4x);
		--borderRadius2: var(--sp2x);
		--borderRadius3: var(--sp2x);
		--borderRadius4: var(--sp63x);
		--imageSize3: var(--sp26x);
		--imgMarginL: var(--sp6x);
		--imgMarginB: var(--sp7x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp8x);
		--gap: var(--sp3x);
		--wrapperMarginT: var(--sp5x);
		--titleMarginT: var(--sp5x);
		--borderRadius: var(--sp3x);
		--borderRadius4: var(--sp50x);
		--imageSize3: var(--sp20x);
		--marginR: var(--sp6x);
		--imgMarginL: var(--sp4x);
		--imgMarginB: var(--sp5x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp13x);
		--wrapperMarginT: var(--sp4x);
		--gap: var(--sp2-5x);
		--titleMarginT: var(--sp4x);
		--borderRadius2: var(--sp1-5x);
		--borderRadius3: var(--sp1-5x);
		--borderRadius4: var(--sp23x);
		--imageSize3: var(--sp18x);
		--marginR: var(--sp5x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginT: var(--sp7x);
		--marginR: var(--sp5x);
		--wrapperMarginT: var(--sp6x);
		--titleMarginT: var(--sp3x);
		--titleMarginB: var(--sp2x);
		--borderRadius: var(--sp2x);
		--borderRadius4: var(--sp41x);
		--imageSize3: var(--sp17x);
		--imgMarginL: var(--sp3x);
		--imgMarginB: var(--sp4x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp11x);
		--marginR: var(--sp4x);
		--gap: var(--sp2x);
		--borderRadius: var(--sp1-5x);
		--borderRadius4: var(--sp32x);
		--imageSize3: var(--sp13x);
		--imgMarginB: var(--sp3x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--marginT: var(--sp10x);
		--marginR: var(--sp3x);
		--wrapperMarginT: var(--sp3x);
		--titleMarginT: var(--sp2-5x);
		--borderRadius: var(--sp1x);
		--borderRadius2: var(--sp1x);
		--borderRadius3: var(--sp1x);
		--borderRadius4: var(--sp24x);
		--imageSize3: var(--sp10x);
		--imgMarginL: var(--sp2x);
		--imgMarginB: var(--sp2-5x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--marginT: var(--sp8x);
		--marginR: 0;
		--wrapperMarginT: 0;
		--gap: var(--sp4x);
		--titleMarginB: var(--sp1x);
		--borderRadius: var(--sp1-5x);
		--borderRadius2: var(--sp2x);
		--borderRadius3: var(--sp2x);
		--borderRadius4: var(--sp36x);
		--imageSize3: var(--sp14x);
		--imgMarginB: var(--sp4x);

		.benefit-image-wrapper {
			margin-top: var(--sp5x);
		}

		.wrapper-titles {
			flex-direction: column;
			align-items: start;
			gap: var(--sp2x);
		}

		.wrapper-benefits > div {
			&:nth-child(1) {
				order: 1;
				margin-top: var(--sp5x);
			}

			&:nth-child(2) {
				margin-top: var(--sp5x);
				order: 3;
			}

			&:nth-child(3) {
				margin-top: var(--sp5x);
				order: 5;
			}

			&:nth-child(4) {
				order: 2;
			}

			&:nth-child(5) {
				order: 4;
			}

			&:nth-child(6) {
				order: 6;
			}
		}
	}
`;

export default BenefitsStyle;
